/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOneBaseAodRulesControllerAodRuleQueryResponse, GetOneBaseAodRulesControllerAodRulePathParams, GetOneBaseAodRulesControllerAodRuleQueryParams } from "../models/GetOneBaseAodRulesControllerAodRule";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOneBaseAodRulesControllerAodRule } from "../axios/getOneBaseAodRulesControllerAodRule";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOneBaseAodRulesControllerAodRuleQueryKey = (id: GetOneBaseAodRulesControllerAodRulePathParams["id"], params: GetOneBaseAodRulesControllerAodRuleQueryParams = {}) => ["audit-reports-api", { url: '/aod-rules/:id', params: {id:id} }, ...(params ? [params] : [])] as const

export type GetOneBaseAodRulesControllerAodRuleQueryKey = ReturnType<typeof getOneBaseAodRulesControllerAodRuleQueryKey>

export function getOneBaseAodRulesControllerAodRuleQueryOptions(id: GetOneBaseAodRulesControllerAodRulePathParams["id"], params?: GetOneBaseAodRulesControllerAodRuleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOneBaseAodRulesControllerAodRuleQueryKey(id, params)
        return queryOptions<GetOneBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, GetOneBaseAodRulesControllerAodRuleQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOneBaseAodRulesControllerAodRule(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve a single AodRule
 * {@link /aod-rules/:id}
 */
export function useGetOneBaseAodRulesControllerAodRule<TData = GetOneBaseAodRulesControllerAodRuleQueryResponse, TQueryData = GetOneBaseAodRulesControllerAodRuleQueryResponse, TQueryKey extends QueryKey = GetOneBaseAodRulesControllerAodRuleQueryKey>(id: GetOneBaseAodRulesControllerAodRulePathParams["id"], params?: GetOneBaseAodRulesControllerAodRuleQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetOneBaseAodRulesControllerAodRuleQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getOneBaseAodRulesControllerAodRuleQueryKey(id, params)
         

         const query = useQuery({
          ...getOneBaseAodRulesControllerAodRuleQueryOptions(id, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}